import axios from "axios";
import { Message } from "element-ui";
import router from "../router";
import { mymessage } from "@/utils/mymessage";

axios.interceptors.response.use(
  (success) => {
    if (success.status && success.status == 200 && success.data.status > 200) {
      Message.error({ message: success.data.msg });
      return;
    }
    if (success.data.msg && success.data.msg != "success") {
      Message.success({ message: success.data.msg });
    }
    return success.data;
  },
  (error) => {
    if (error.response.status == 504 || error.response.status == 404) {
      Message.error({ message: "服务器被吃了( ╯□╰ )" });
    } else if (error.response.status == 403) {
      Message.error({ message: "权限不足，请联系管理员" });
    } else if (error.response.status == 401) {
      mymessage.error({
        message: error.response.data.msg
          ? error.response.data.msg
          : "尚未登录，请登录",
      });
      router.replace("/");
    } else {
      if (error.response.data.msg) {
        Message.error({ message: error.response.data.msg });
      } else {
        Message.error({ message: "未知错误!" });
      }
    }
    return;
  }
);

let base = "";

export const postKeyValueRequest = (url, data, params) => {
  return axios({
    method: "post",
    url: `${base}${url}`,
    params: params,
    data: data,
    transformRequest: [
      function(data) {
        let ret = "";
        for (let i in data) {
          ret +=
            encodeURIComponent(i) + "=" + encodeURIComponent(data[i]) + "&";
        }
        return ret;
      },
    ],
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};
export const postRequest = (url, data, params) => {
  return axios({
    method: "post",
    url: `${base}${url}`,
    data: data,
    params: params,
  });
};
export const putRequest = (url, data, params) => {
  return axios({
    method: "put",
    url: `${base}${url}`,
    data: data,
    params: params,
  });
};
export const getRequest = (url, params) => {
  return axios({
    method: "get",
    url: `${base}${url}`,
    params: params,
  });
};
export const deleteRequest = (url, params) => {
  return axios({
    method: "delete",
    url: `${base}${url}`,
    params: params,
  });
};


export const  apiGeocode = (address, adcode = null) => {
  const params = {
    key: '46b7f6a4de3555f682a2b9133bf4933d',
    address
  }
  if (adcode) {
    params.city = adcode
  }
  return axios
    .request({
      url: 'https://restapi.amap.com/v3/geocode/geo',
      params
    })
    .then((response) => {
      const { status } = response
	  if (status == '1') {
	    return response.geocodes[0].location
	  } else {
	    return null
	  }
      // if (response.status === 200 && status == '1') {
      //   return response.geocodes[0].location
      // } else {
      //   return null
      // }
    })
}

